/**
 * Tabbed product information panel for the product page.
 */
class ProductInfoTabs extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleTabClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleTabClick);
  }

  /** @param {MouseEvent} event */
  #handleTabClick = (event) => {
    const tab = event.target instanceof Element ? event.target.closest('.kg-tab') : null;

    if (!tab || !this.contains(tab)) return;

    const target = tab.getAttribute('data-tab');
    if (!target) return;

    this.querySelectorAll('.kg-tab').forEach((button) => {
      const isActive = button === tab;
      button.classList.toggle('kg-tab--active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.querySelectorAll('.kg-panel__content').forEach((panel) => {
      const isActive = panel.getAttribute('data-panel') === target;
      panel.classList.toggle('kg-panel__content--active', isActive);
      panel.toggleAttribute('hidden', !isActive);
    });
  };
}

if (!customElements.get('product-info-tabs')) {
  customElements.define('product-info-tabs', ProductInfoTabs);
}
